<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ADMIN_ROLE } from '@utils/constant'
import { ErrorWrapper } from '@utils/error-handler'
import { batchComputed, batchListMethod, authComputed } from '@state/helpers'

export default {
  page: {
    title: 'Batch List',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Table,
  },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      lists: [],
      fields: [
        {
          value: 'name',
          text: 'Name',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'assigned_by.email',
          text: 'Assigned By',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'courseId',
          text: 'Course Assigned',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'assignedTo',
          text: 'Assigned Students',
          sortable: false,
          colType: 'default',
        },
        {
          value: 'action',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        {
          key: 'name',
          label: 'Name',
          colType: 'default',
        },
        {
          key: 'assigned_by',
          label: 'Assigned By',
          colType: 'default',
        },
        {
          key: 'course_id',
          label: 'Course Assigned',
          colType: 'list',
        },
        {
          key: 'teacher_id',
          label: 'Assigned Teacher(s)',
          colType: 'list',
        },
        {
          key: 'assigned_to',
          label: 'Assigned Students',
          colType: 'list',
        },
      ],
    }
  },
  computed: {
    ...batchComputed,
    ...authComputed,
  },
  mounted() {
    this.getListOfBatches()
  },
  methods: {
    ...batchListMethod,

    // Get list of all batchs role wise
    getListOfBatches() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 10,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchBatchList({
        filter,
      })
        .then((batchList) => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <router-link tag="button" to="/batch-add" class="btn btn-info mb-2">
              <i class="ti-plus"></i><span> Add Batch</span>
            </router-link>
            <Table
              :fields="fields"
              :items="batchList ? batchList.docs : []"
              :editbtn="true"
              :viewbtn="true"
              :deletebtn="true"
              :batch="true"
              :display-fields="displayFields"
            >
            </Table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
